import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  card: {
    background: 'rgba(255,255,255,0.92)',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.75, 1.5),
    boxShadow: theme.shadows[2],
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  label: {
    marginRight: theme.spacing(1),
    '& .MuiFormControlLabel-label': {
      fontSize: 13,
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      gap: 6,
    },
  },
  swatch: {
    display: 'inline-block',
    width: 12,
    height: 12,
    borderRadius: 3,
    flexShrink: 0,
  },
  checkbox: {
    padding: 4,
  },
  orderGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  orderFilters: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingLeft: theme.spacing(3.5),
    gap: theme.spacing(0.25),
  },
  filterLabel: {
    marginRight: theme.spacing(0.5),
    '& .MuiFormControlLabel-label': {
      fontSize: 12,
      fontWeight: 400,
      color: theme.palette.text.secondary,
    },
  },
}));
